import React from 'react';
import { MdRocketLaunch } from 'react-icons/md';
import { glassStyle } from './themes';

/** Mid-page CTA banner — purple-glow card with a single signup button. */
export default function CTABanner({ t, onSignupClick }) {
  return (
    <div style={{ maxWidth: 1200, margin: '0 auto', padding: '80px 24px', position: 'relative', zIndex: 1 }}>
      <div style={{ ...glassStyle(t), padding: 'clamp(40px,6vw,80px)', textAlign: 'center', background: 'linear-gradient(135deg, rgba(124,58,237,0.18) 0%, rgba(79,70,229,0.12) 100%)', border: '1px solid rgba(124,58,237,0.28)', borderRadius: 24 }}>
        <h2 style={{ fontSize: 'clamp(26px,4vw,46px)', fontWeight: 800, color: t.text, letterSpacing: '-1.5px', lineHeight: 1.15, margin: '0 0 18px' }}>
          Ready to own your{' '}
          <span style={{ background: 'linear-gradient(to right, #A78BFA, #60A5FA)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>digital brand?</span>
        </h2>
        <p style={{ color: t.textSub, fontSize: 18, maxWidth: 480, margin: '0 auto 32px' }}>Start free. No limits on brands. Scale when you're ready.</p>
        <button
          onClick={onSignupClick}
          style={{ height: 56, padding: '0 40px', borderRadius: 14, background: 'linear-gradient(135deg, #7C3AED, #4F46E5)', color: '#fff', fontWeight: 700, fontSize: 17, border: 'none', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: 8, transition: 'all 0.25s' }}
          onMouseEnter={(e) => { e.currentTarget.style.opacity = '0.9'; e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 16px 48px rgba(124,58,237,0.5)'; }}
          onMouseLeave={(e) => { e.currentTarget.style.opacity = '1'; e.currentTarget.style.transform = 'none'; e.currentTarget.style.boxShadow = 'none'; }}
        >
          <MdRocketLaunch size={18} /> Launch Your Brand Free
        </button>
      </div>
    </div>
  );
}
